(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/game-unavailable.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/game-unavailable.js');
"use strict";

const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const defaultProps = {
  title: 'Något gick fel',
  message: 'Just nu är våra Fler Lotter-spel inte tillgängliga.',
  subMessage: 'Vänligen försök igen senare.',
  action: {
    href: svs.core.urlMapping.get('startPage'),
    label: 'Till startsidan'
  }
};
const GameUnavailable = function () {
  let {
    title,
    message,
    subMessage,
    action
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps;
  return React.createElement("div", {
    className: "padding-3 align-center f-content tickets-einstant-game-unavailable"
  }, React.createElement(Icon, {
    icon: "exclamation-sign tickets-einstant-fler-lotter-new-700",
    size: 900
  }), React.createElement("h2", {
    className: "h1 margin-v-1 tickets-einstant-fler-lotter-new-700"
  }, title), React.createElement("p", {
    className: "margin-bottom-2"
  }, message, React.createElement("br", null), subMessage), React.createElement(Button, {
    className: "qa-button-start-page tickets-einstant-button-theme",
    inverted: true,
    onClick: () => {
      window.location.href = action.href;
    }
  }, action.label));
};
setGlobal('svs.eInstant.components.GameUnavailable', GameUnavailable);

 })(window);